import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './ContactSales.css';
import { getApiOrigin } from '../../services/config';

export default function ContactSales() {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: '',
    website: '' // Honeypot field
  });
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: '', message: '' });
  const timestampRef = useRef(Date.now());

  // Set timestamp when component mounts
  useEffect(() => {
    timestampRef.current = Date.now();
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: '', message: '' });

    try {
      const apiOrigin = getApiOrigin();
      const response = await fetch(`${apiOrigin}/api/contact-us/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...formData,
          timestamp: timestampRef.current
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setStatus({
          type: 'success',
          message: data.message || t('contact_success')
        });
        // Reset form
        setFormData({
          name: '',
          email: '',
          phone: '',
          company: '',
          message: '',
          website: ''
        });
        // Reset timestamp for next submission
        timestampRef.current = Date.now();
      } else {
        setStatus({
          type: 'error',
          message: data.error || t('contact_error')
        });
      }
    } catch (error) {
      setStatus({
        type: 'error',
        message: t('contact_network_error')
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact">
      <h1>{t('contact_title')}</h1>
      <p>{t('contact_subtitle')}</p>

      {status.message && (
        <div className={`contact__message contact__message--${status.type}`}>
          {status.message}
        </div>
      )}

      <form onSubmit={handleSubmit} className="contact__form">
        <input
          name="name"
          placeholder={t('contact_name')}
          required
          value={formData.name}
          onChange={handleChange}
          disabled={loading}
        />
        <input
          type="email"
          name="email"
          placeholder={t('contact_email')}
          required
          value={formData.email}
          onChange={handleChange}
          disabled={loading}
        />
        <input
          type="tel"
          name="phone"
          placeholder={t('contact_phone')}
          required
          value={formData.phone}
          onChange={handleChange}
          disabled={loading}
        />
        <input
          name="company"
          placeholder={t('contact_company')}
          value={formData.company}
          onChange={handleChange}
          disabled={loading}
        />
        <textarea
          name="message"
          placeholder={t('contact_message')}
          rows={5}
          value={formData.message}
          onChange={handleChange}
          disabled={loading}
        />
        {/* Honeypot field - hidden from users but visible to bots */}
        <input
          type="text"
          name="website"
          placeholder={t('contact_website')}
          value={formData.website}
          onChange={handleChange}
          className="contact__honeypot"
          tabIndex="-1"
          autoComplete="off"
        />
        <button type="submit" className="btn primary" disabled={loading}>
          {loading ? t('contact_sending') : t('contact_send')}
        </button>
      </form>
    </div>
  );
}
